export default __webpack_public_path__ + "static/media/mons17.71de4c61.jpg";